const state = {
  isLoadingStatus: false,
};

const getters = {
  GetIsLoadingStatus: (state) => {
    return state.isLoadingStatus;
  },
};

export { state, getters };
